import http from "../httpService"
import { LNotification } from "@lib/abpUtility"
import { notifySuccess } from "@lib/helper"
import { downloadFile } from "@lib/helperFile"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import type {
  IExportJobLog,
  IExportJobLogFilter,
} from "@models/export/exportJobLogModel"

/**
 * Feature-0213 Export Core — hộp thư tệp đã xuất.
 * BE siết `CreatorUserId == user hiện tại` ở mọi truy vấn nên không cần truyền user.
 */
class ExportJobLogService {
  async getMyExports(
    params: IExportJobLogFilter
  ): Promise<PagedResultDto<IExportJobLog>> {
    const res = await http.get("api/services/app/ExportJobLog/GetMyExports", {
      params,
    })
    return res.data.result
  }

  async download(item: IExportJobLog): Promise<void> {
    const res = await http.get("api/Export/DownloadExportedFile", {
      params: { id: item.id },
      responseType: "blob",
    })
    downloadFile(res.data, item.fileName)
  }

  async delete(id: number): Promise<void> {
    await http.post("api/services/app/ExportJobLog/Delete", { id })
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("DELETE_SUCCESSFULLY")
    )
  }
}

export default new ExportJobLogService()
